<template>
  <!--  采购入库单-->
  <div class="page-template add-page order-add-page">
    <div class="page-title">{{ title }}</div>
    <div class="btn-box">
      <el-button @click="beBack" type="primary" plain>返回</el-button>
      <el-button @click="refresh" type="primary" plain v-show="formModel.reviewerStatus !==10">刷新</el-button>
      <el-button @click="submitAuth" type="primary" plain>保存</el-button>
      <el-button @click="audit(3)" type="primary" plain :disabled="formModel.reviewerStatus === null">审核</el-button>
      <el-button @click="complexFunc" type="primary" plain
      >{{ complexShow ? "收起" : "展开" }}
        <i class="el-icon-arrow-up" v-show="complexShow"></i>
        <i class="el-icon-arrow-down" v-show="!complexShow"></i>
      </el-button>
    </div>
    <list-operation-form v-show="complexShow" v-loading="loading" ref="listOperationForm"
                         :formOptions="listFormOptions" @valueChange="listFormValueChange"></list-operation-form>

    <div class="search-goods-box">
      <el-input id="goodsText"
                placeholder="条码/自编码/助记码"
                v-model="goodsTxt"
                class="search-goods-input"
                @change="search"
      >
        <template slot="prepend">
          <span>综合搜索</span>
        </template>
        <template slot="append">
          <!--<div class="el-icon-search more-btn" @click="search"></div>-->
          <div class="el-icon-search more-btn"></div>
        </template>
      </el-input>
      <el-button @click="checkGoods" type="primary" plain class="select-good">选择商品</el-button>
      <!--<el-button @click="downloadTemplate" type="primary" plain>下载模板</el-button>-->
      <!--<el-button @click="importData" type="primary" plain>导入商品</el-button>-->
      <el-button @click="openImport" type="primary" plain>导入商品</el-button>
    </div>
    <list-operation-new
      ref="listOperation"
      :tableOptions="listColumns"
    ></list-operation-new>
    <el-dialog
      title="商品列表"
      :visible.sync="listShow"
      width="1200px"
      height="800"
      :close-on-click-modal="false"
    >
      <good-list
        ref="goodsListOperation"
        v-if="listShow"
        @rowCheck="rowCheck"
        :isSelect="goodListSelect"
        :tableOptions="tableOptions"
        @selectSubmit="rowsSelectSubmit"
        :otherParam="otherParam"
        :selectUrl="selectUrl"
        :listTableData="listTableData"
      ></good-list>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="importShow" custom-class="importDialog" :close-on-click-modal="false">
      <import-template v-if="importShow" ref="importTemplate" :importShow="importShow"
                       @importFile="importData" @downTemplate="downloadTemplate"></import-template>
    </el-dialog>
  </div>
</template>
<script>
  // 商品列表组件
  import goodList from '@/components/business/goodList';
  // 表单单组件
  import listOperationNew from "@/components/template/listOperationNew";
  // 要货单搜索组件
  import listOperationForm from '@/components/template/listOperationForm';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower'
  // 导入模版组件
  import importTemplate from '@/components/business/importTemplate';

  export default {
    mixins: [userPower],
    components: {
      listOperationNew,
      goodList,
      listOperationForm,
      importTemplate
    },
    data() {
      return {
        copyParams: {},
        importShow: false,
        isCheck: false,
        complexShow: true,
        goodsTxt: "",
        listTableData: [], // 用于传给选择商品组件，判断是否已被选择
        loading: false,
        goodListSelect: false,
        title: '',
        listShow: false,
        goodList: [],
        dialogShow: false,
        formModel: {
          reviewerStatus: null
        },
        isSelectSupplier: true, // 判断是否选择供应商
        isSelectWarehouse: true,
        isClearTableData: true,
        selectUrl: {url: api.warehouse.warehouseGoods},
        otherParam: {statusList: [10, 20], isOpenCombination: 2},
        // 头部条件
        listFormOptions: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            }
          },
          labelWidth: '130px',
          columns: [
            {
              prop: 'id',
              hidden: true
            },
            {
              label: '业务单号',
              type: 'input',
              prop: 'orderNo',
              span: 8,
              disabled: true
            },
            {
              label: '采购门店',
              type: 'storeInputDialog',
              prop: 'storeId',
              data: [],
              span: 8,
              isHasAll: true, // 下拉选择添加‘总部’字段
              disabled: false,
              // url: this.storeUrl,
              //change: this.purchaseStoreChange
            },
            {
              label: '供应商',
              type: 'supplierInputDialog',
              prop: 'supplierId',
              data: [],
              span: 8,
              // url: api.archives.supplier,
              //change: this.supplierChange,
              disabled: false,
              isEditSupplier: false,
              param: {type: 10}
            },
            {
              label: '仓库',
              type: 'warehouseInputDialog',
              prop: 'warehouseId',
              disabled: false,
              data: [],
              //change: this.warehouseChange,
              // url: api.warehouse.warehouse,
              span: 8
            },
            {
              label: '经手人',
              prop: 'handler',
              type: 'input',
              maxLength: 16,
              span: 8
            },
            {
              label: '采购订单',
              type: 'orderDialog',
              prop: 'purchaseOrderNo',
              data: [],
              labelKey: 'orderNo',
              uniqueKey: 'orderNo',
              change: this.purchaseOrderNoChange,
              span: 8,
              url: api.purchase.procurement,
              columns: [
                {label: "单号", prop: "orderNo", align: "center"},
                {label: "金额", prop: "orderAmt", align: "center"},
                {label: "数量", prop: "goodsNum", align: "center"}
              ]
            },
            {
              prop: 'purchaseId',
              hidden: true
            },
            {
              label: '来货日期',
              prop: 'goodsArriveDttm',
              type: 'datePicker',
              span: 8
            },
            {
              label: '备注',
              type: 'input',
              maxLength: 16,
              prop: 'remarks',
              span: 8
            }
          ]
        },
        goodsCopyList: [],
        // 添加表格字段
        listColumns: {
          height: this.height,
          summaryColumns: ['retailPrice', 'goodsNum', 'salesAmount', 'totalPrice', 'price', 'buyPrice', 'noStorageNum', 'giveGoodsNum', 'discountRate'],
          columns: [
            {label: '操作', type: 'operation', width: 100, prop: 'operation'},
            {label: '序号', type: 'index', width: 60, prop: 'idx'},
            {
              label: '条码',
              prop: 'barCode',
              // type: 'input',
              width: '150',
            },
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '90'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '60'
            },
            {
              label: '单位',
              width: '60',
              prop: 'unitName'
            },
            {
              label: '自编码',
              width: '90',
              prop: 'artNo'
            },
            {
              label: '档案进价',
              width: '90',
              prop: 'buyPrice'
            },
            {
              label: '实际入库数量',
              width: '110',
              prop: 'goodsNum',
              // max: 9999.999,
              type: 'inputNumber',
              change: this.numChange,
              precision: 3
            },
            {
              label: '赠送数量',
              width: '90',
              max: 9999.999,
              prop: 'giveGoodsNum',
              type: 'inputNumber',
              change: this.giveGoodsNumChange,
              precision: 3
            },
            {
              label: '进价',
              width: '120',
              prop: 'price',
              // max: 99999.99,
              type: 'inputNumber',
              change: this.priceChange,
              precision: 3
            },
            // {
            //   label: "折扣",
            //   width: "90",
            //   prop: "discountRate",
            //   type: "inputNumber",
            //   change: this.rateChange,
            //   precision: 2,
            // },
            {
              label: '小计金额',
              width: '120',
              prop: 'totalPrice',
              type: 'inputNumber',
              // max: 99999.99,
              change: this.totalPriceChange,
              precision: 3
            },
            {
              label: '零售价',
              width: '120',
              prop: 'retailPrice'
            },
            {
              label: '零售金额',
              width: '90',
              prop: 'salesAmount'
            },
            {
              label: '不入库数量',
              width: '110',
              prop: 'noStorageNum',
              precision: 2
            },
            {
              label: '生产日期',
              width: '220',
              type: 'dateTimePicker',
              dataType: 'datetimeRange',
              prop: 'produceDttm'
            },
            {
              label: '系统库存',
              width: '90',
              prop: 'inventoryNum'
            },
            {
              label: '备注',
              prop: 'remarks',
              maxLength: 16,
              type: 'input',
              width: '200'
            },


          ]

        },
        // 商品表格信息配置
        tableOptions: {
          indexShow: true, // 是否显示索引
          indexMethod: (index) => {
            // 自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '条码',
              prop: 'barCode',
              width: '190',
              align: 'center'
            },
            {
              label: '品名',
              prop: 'goodsName',
              width: '100',
              align: 'center'
            },
            {
              label: '规格',
              prop: 'specs',
              width: '100',
              align: 'center'
            },
            {
              label: '单位',
              prop: 'unitName',
              width: '200',
              align: 'center'
            },
            {
              label: '进货价',
              prop: 'buyPrice',
              width: '150',
              align: 'center'
            },
            {
              label: '零售价',
              prop: 'retailPrice',
              width: '150',
              align: 'center'
            },
            {
              label: '库存',
              prop: 'inventoryNum',
              width: '150',
              align: 'center'
            }
          ],
          param: this.otherParam,
          url: api.archives.goodsInfoIncludeSpecs
        },
        checkIndex: '',
        supplierInfo: {},
        settingInfo: {}// 设置信息
      };
    },
    watch: {},
    beforeCreate() {
      this.height = document.documentElement.clientHeight - 180 - 200
    },
    created() {
      this.title = (this.$route.query.id ? '编辑' : '新增') + document.title;
      this.getStoreList();
      if (this.$route.query.id) {
        this.getDetail();
      } else {
        this.$nextTick(() => {
          this.$refs.listOperationForm.formModel.warehouseId = this.$utils.getSysUser().warehouseId;
          this.isSelectWarehouse = false;
          this.copyParams.warehouseId = this.$utils.getSysUser().warehouseId;
          this.listFormOptions.columns.filter(item => item.prop === "purchaseOrderNo")[0].params = this.copyParams;
        })
      }
      this.setStoreId(this.listFormOptions.columns);
      this.getSettingStatus();
      // let user = this.$utils.getSysUser();
      // if (user.storeId) {
      //   this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].url = api.store.store
      // }else{
      //   this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].url = api.store.store
      // }
    },
    methods: {
      complexFunc() {
        if (!this.isCheck) {
          this.complexShow = !this.complexShow;
        }
      },
      listFormValueChange(value, column) {
        if (column.prop === "storeId") {
          this.listFormOptions.columns.filter(
            item => item.prop === "supplierId"
          )[0].params = {storeId: value.id};
          this.listFormOptions.columns.filter(
            item => item.prop === "warehouseId"
          )[0].params = {storeId: value.id};
          this.listFormOptions.columns.filter(
            item => item.prop === "purchaseOrderNo"
          )[0].params = {storeId: value.id};
        }

        if (column.prop === "storeId") {
          this.otherParam.storeId = value.id;
          this.copyParams.storeId = value.id;
          this.$refs.listOperationForm.$refs.supplierInputDialog[0].initData();
          this.$refs.listOperationForm.$refs.orderDialog[0].initData();
          // this.$refs.listOperationForm.$refs.warehouseInputDialog[0].initData();
          this.$refs.listOperationForm.formModel.supplierId = "";
          this.$refs.listOperationForm.formModel.purchaseOrderNo = "";
          this.$refs.listOperationForm.formModel.storeId = value.id;
          if (value.warehouseId) {
            this.$refs.listOperationForm.formModel.warehouseId = value.warehouseId;
            this.otherParam.warehouseId = value.warehouseId;
            this.copyParams.warehouseId = value.warehouseId;
            this.isSelectWarehouse = false;
          }
          this.listFormOptions.columns.filter(item => item.prop === "purchaseOrderNo")[0].params = this.copyParams;
        } else if (column.prop === "supplierId") {
          this.otherParam.supplierId = value;
          this.isSelectSupplier = false;
          this.copyParams.supplierId = value;
          this.listFormOptions.columns.filter(item => item.prop === "purchaseOrderNo")[0].params = this.copyParams;
          this.$refs.listOperationForm.$refs.orderDialog[0].initData();
          this.$refs.listOperationForm.formModel.purchaseOrderNo = "";
        } else if (column.prop === "warehouseId") {
          this.otherParam.warehouseId = value;
          this.isSelectWarehouse = false;
          this.copyParams.warehouseId = value;
          this.listFormOptions.columns.filter(item => item.prop === "purchaseOrderNo")[0].params = this.copyParams;
          this.$refs.listOperationForm.$refs.orderDialog[0].initData();
          this.$refs.listOperationForm.formModel.purchaseOrderNo = "";
        }
        this.$refs['listOperation'].clearTableData();
        if (column.prop === "purchaseOrderNo") {
          this.purchaseOrderNoChange(value);
        }
      },

      search() {
        if (this.goodsTxt === '' || this.goodsTxt === null) return;
        this.otherParam.otherName = this.goodsTxt;
        if (!this.settingInfo.supplierGoods) {
          this.supplierInfo.supplierId = "";
        }
        this.otherParam = {...this.otherParam, ...this.supplierInfo};
        if (this.isSelectSupplier) {
          this.goodsTxt = ''
          this.$confirm("请选择供应商！", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          });
        } else {
          if (this.isSelectWarehouse) {
            this.goodsTxt = ''
            this.$confirm("请选择仓库！", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            });
          } else {
            this.isCheck = true;
            this.$axios
              .fetchPost(api.warehouse.warehouseGoods + "/list", this.otherParam)
              .then(res => {
                if (res.code === 200) {
                  if (res.data.length > 0) {
                    let tableData = res.data;
                    if (tableData.length === 1) {
                      let row = tableData[0];
                      let tableList = this.$refs["listOperation"].getTabelData();
                      let flag = true;
                      if (tableList.length > 0) {
                        tableList.forEach(item => {
                          if (flag) {
                            if (item.barCode === row.barCode) flag = false;
                          }
                        });
                      }
                      if (!flag) {
                        this.$message.warning("[名称:" + row.goodsName + ",条码:" + row.barCode + "],已存在！！！");
                        return;
                      }
                      row.goodsNum = 0.0.toFixed(3); // 数量
                      row.giveGoodsNum = 0.0.toFixed(3); // 赠送数量
                      row.salesAmount = 0.0.toFixed(2); // 销售金额
                      row.price = row.buyPrice; // 价格
                      row.totalPrice = 0.0.toFixed(2); // 小计金额
                      row.noStorageNum = 0.0.toFixed(2); // 不入库数量
                      row.discountRate = 1.0.toFixed(2); // 折扣率
                      row.isFinalNum = 1; // 是否是商品最终入库数量
                      row.name = row.goodsName;
                      row.remarks = null;
                      // this.$refs["listOperation"].addMoreRow(row, tableList.length);
                      this.$refs["listOperation"].setColumnData(row, tableList.length);
                      this.currentTableList = this.$refs["listOperation"].getTabelData();
                      this.$message.success("商品添加成功");
                    } else {
                      this.queryGoodsList();
                    }
                  } else {
                    this.$message.warning("[条码:" + this.goodsTxt + "],商品不存在！！！");
                  }
                } else {
                  this.$message({type: "error", message: res.msg});
                }
              })
              .catch(err => {
              }).finally(() => {
              this.clearQueryParam();
              this.isCheck = false;
            });
          }
        }
      },
      clearQueryParam() {
        this.goodsTxt = '';
        this.otherParam.otherName = '';
      },
      queryGoodsList() {
        this.listShow = true;
        this.goodListSelect = true;
        this.listTableData = this.$refs["listOperation"].getTabelData(); // table数据  原始的
        if (!this.settingInfo.supplierGoods) {
          this.supplierInfo.supplierId = "";
        }
        this.$nextTick(() => {
          this.otherParam = {...this.otherParam, ...this.supplierInfo};
        });
      },
      getStoreList() {
        let user = this.$utils.getSysUser();
        if (user.storeId) {
          this.$axios.fetchPost(api.store.store + '/list', {}).then(data => {
            if (data.code === 200) {
              this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].data = data.data;
            } else {
              this.$message({message: '获取采购门店失败!', type: 'error'});
            }
          });
        } else {
          this.$axios.fetchPost(api.purchase.purchaseStoreList + '/list', {}).then(data => {
            if (data.code === 200) {
              this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].data = data.data;
              data.data.unshift({id: -1, name: '总部'});
            } else {
              this.$message({message: '获取采购门店失败!', type: 'error'});
            }
          });
        }
      },
      // 获取设置状态
      getSettingStatus(val) {
        // 获取设置信息 接口
        this.$axios.fetchGet(api.purchase.pcPurchaseDefaultInfo, {}).then(res => {
          if (res.code === 200) {
            if (res.data) {
              this.settingInfo = res.data
            }
          } else {
            this.$message({type: 'error', message: res.msg});
          }
        }).catch(err => {
        })
      },
      // 编辑详情
      getDetail() {
        this.loading = true;
        this.$axios
          .fetchGet(api.purchase.stock + '?id=' + this.$route.query.id, {})
          .then((data) => {
            this.formModel.reviewerStatus = data.data.reviewerStatus
            this.loading = false;
            if (data.code === 200) {
              this.listFormOptions.columns.filter(item => item.prop === 'supplierId')[0].isEditSupplier = true;
              // 为头部表单赋值
              this.$refs.listOperationForm.formModel = data.data;
              this.purchaseStoreChange({storeId: data.data.storeId})
              this.goodsCopyList = this.$utils.deepClone(
                data.data.pcGoodsMapList
              );
              this.goodsCopyList.map((item) => {
                item.goodsNum = item.goodsNum + item.noStorageNum;
              });
              // 选择商品 所需参数
              this.isSelectSupplier = false;
              this.supplierInfo.storeId = data.data.storeId;// 门店id
              this.supplierInfo.warehouseId = data.data.warehouseId// 仓库id
              this.otherParam.storeId = data.data.storeId;// 门店id,barcode查询需要的参数
              this.isSelectWarehouse = false;
              this.isClearTableData = false;
              this.listFormOptions.columns.filter(item => item.prop === 'storeId')[0].disabled = true;
              this.listFormOptions.columns.filter(item => item.prop === 'supplierId')[0].disabled = true;
              this.listFormOptions.columns.filter(item => item.prop === 'warehouseId')[0].disabled = true;
              this.listFormOptions.columns.filter(item => item.prop === 'handler')[0].disabled = true;
              this.listFormOptions.columns.filter(item => item.prop === 'purchaseOrderNo')[0].disabled = true;
              // 为表格赋值
              this.$refs['listOperation'].addMoreRow(data.data.pcGoodsMapList, 0);
              this.currentTableList = this.$refs['listOperation'].getTabelData();
            } else {
              this.$message({message: data.msg, type: 'error'});
            }
          })
          .catch((err) => {
            this.$message({message: '请求失败！', type: 'error'});
            this.loading = false;
          });
      },
      // 选择供应商
      supplierChange(data) {
        let editSupplier = this.listFormOptions.columns.filter(item => item.prop === 'supplierId')[0].isEditSupplier;
        if (editSupplier === false) {
          if (data.supplierId) {
            this.isSelectSupplier = false;
            this.getPurchaseOrderNo(data);
            this.$refs['listOperation'].clearTableData();
            this.supplierInfo.supplierId = data.supplierId;
          } else {
            this.isSelectSupplier = true;
          }
        } else {
          this.listFormOptions.columns.filter(item => item.prop === 'supplierId')[0].isEditSupplier = false;
        }
      },
      // 输入折扣
      rateChange(row, index) {
        if (row.discountRate) {
          row.totalPrice = parseFloat(row.goodsNum * row.price * row.discountRate).toFixed(2);
        }
        this.$refs['listOperation'].setCountData(row, index);
      },
      // 返回按钮事件
      beBack() {
        if (!this.isCheck) {
          this.$router.go(-1);
        }
      },
      // 刷新
      refresh() {
        if (!this.isCheck) {
          this.$router.go(0);
        }
      },
      // 审核
      audit(e) {
        if (!this.isCheck) {
          this.submitAuth(e);
        }
      },
      // 点击选择商品 多选
      checkGoods() {
        if (!this.isCheck) {
          if (this.isSelectSupplier) {
            this.$confirm('请选择供应商！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            });
          } else {
            if (this.isSelectWarehouse) {
              this.$confirm('请选择仓库！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              });
            } else {
              this.queryGoodsList();
            }
          }
        }
      },
      // 单条 选择某行数据
      rowCheck(row) {
        this.listShow = false;
        row.goodsNum = 0.0.toFixed(3); // 数量
        row.giveGoodsNum = 0.0.toFixed(3); // 赠送数量
        row.salesAmount = 0.0.toFixed(2); // 销售金额
        row.price = row.buyPrice; // 价格
        row.totalPrice = 0.0.toFixed(2); // 小计金额
        row.noStorageNum = 0.0.toFixed(2); // 不入库数量
        row.discountRate = 1.0.toFixed(2); // 折扣率
        row.isFinalNum = 1; // 是否是商品最终入库数量
        row.name = row.goodsName;
        row.remarks = null;
        this.$refs['listOperation'].setColumnData(row, this.checkIndex);
        this.currentTableList = this.$refs['listOperation'].getTabelData();
      },
      //  多选择商品 确认
      rowsSelectSubmit(rows) {
        rows.map((item) => {
          item.name = item.goodsName;
          item.goodsNum = 0.0.toFixed(3); // 数量
          item.giveGoodsNum = 0.0.toFixed(3); // 赠送数量
          item.salesAmount = 0.0.toFixed(2); // 销售金额
          item.price = item.buyPrice; // 价格
          item.totalPrice = 0.0.toFixed(2); // 小计金额
          item.noStorageNum = 0.0.toFixed(2); // 不入库数量
          item.discountRate = 1.0.toFixed(2); // 折扣率
          item.isFinalNum = 1;
          item.remarks = null;
        });
        this.listShow = false;
        let tableList = this.$refs['listOperation'].getTabelData();
        this.$refs['listOperation'].addMoreRow(rows, tableList.length);
        this.currentTableList = this.$refs['listOperation'].getTabelData();
        // let rowData = this.$utils.deepClone(tableList[index])
        if (rows && rows.length > 0) {
          this.$message.success("商品添加成功");
        }
      },
      numChange(row, index) {
        if (row.goodsNum && row.goodsNum >= 9999.999) {
          row.goodsNum = '9999.999'.toString();
        }
        let rowData = this.$utils.deepClone(this.currentTableList[index]);
        if (row.goodsNum === '' || row.goodsNum == null) {
          row.goodsNum = rowData.goodsNum.toString();
          row.price = rowData.price.toString();
          row.totalPrice = rowData.totalPrice.toString();
          return;
        }
        if (this.goodsCopyList.length !== 0) {
          row.isFinalNum = 1;
          this.goodsCopyList.map((item) => {
            if (item.barCode === row.barCode) {
              if (row.goodsNum > item.goodsNum) {
                this.$confirm(
                  row.name +
                  '：实际入库的剩余数量为' +
                  item.goodsNum +
                  '多余部分请重新制定入库单！',
                  '提示',
                  {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                  }
                )
                  .then(() => {
                    row.goodsNum = item.goodsNum;
                    this.updateData(row, index);
                  })
                  .catch(() => {
                    row.goodsNum = item.goodsNum;
                    this.updateData(row, index);
                  });
              } else if (row.goodsNum < item.goodsNum) {
                // 后端通过这个判断是否是部分退货
                row.noStorageNum = item.goodsNum - row.goodsNum;
                row.isFinalNum = 0;
                this.updateData(row, index);
              }
            }
          });
          this.updateData(row, index);
        } else {
          row.isFinalNum = 1;
          this.updateData(row, index);
        }
      },
      giveGoodsNumChange(row, index) {
        let rowData = this.$utils.deepClone(this.currentTableList[index]);
        if (row.giveGoodsNum === '' || row.giveGoodsNum == null) {
          row.giveGoodsNum = rowData.giveGoodsNum.toString();
        }
        this.$refs['listOperation'].setCountData(row, index);
      },
      updateData(row, index) {
        if (row.retailPrice) {
          row.salesAmount = parseFloat(row.retailPrice * row.goodsNum).toFixed(2);
        }
        if (row.price) {
          row.totalPrice = parseFloat(row.price * row.goodsNum).toFixed(2);
        }
        this.$refs['listOperation'].setCountData(row, index);
      },
      // 输入商品采购价格
      priceChange(row, index) {
        if (row.price && row.price >= 9999.999) {
          row.price = '99999.999'.toString();
        }
        let rowData = this.$utils.deepClone(this.currentTableList[index])
        if (row.price == null || row.price === '') {
          row.price = rowData.price.toString();
        }
        if ((row.price).toString() && row.buyPrice) {
          if (Number(row.price) > Number(row.buyPrice) && this.settingInfo.greaterGoodsPrice) {
            this.$confirm('当前进价大于商品档案进价，确认？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              row.totalPrice = parseFloat(row.price * row.goodsNum).toFixed(2);
              this.$refs['listOperation'].setCountData(row, index);
            }).catch(() => {
              row.price = rowData.price
            })
          } else {
            row.totalPrice = parseFloat(row.price * row.goodsNum).toFixed(2);
            this.$refs['listOperation'].setCountData(row, index);
          }
        }
      },

      totalPriceChange(row, index) {
        // if (row.totalPrice !== null && row.totalPrice !== '' && row.goodsNum !== null && row.goodsNum !== '' && row.goodsNum !== 0) {
        //   row.price = parseFloat(row.totalPrice / row.goodsNum).toFixed(2);
        // }
        if (row.totalPrice && row.totalPrice >= 9999.999) {
          row.totalPrice = '99999.999'.toString();
        }
        let rowData = this.$utils.deepClone(this.currentTableList[index]);
        if (row.totalPrice !== null && row.totalPrice !== '' && row.totalPrice !== undefined) {
          if (row.goodsNum !== null && row.goodsNum !== '' && row.goodsNum !== 0) {
            row.price = parseFloat(row.totalPrice / row.goodsNum).toFixed(2);
            if ((row.price).toString() && rowData.buyPrice) {
              if (Number(row.price) > Number(row.buyPrice) && this.settingInfo.greaterGoodsPrice) {
                this.$confirm('当前进价大于商品档案进价，确认？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  row.price = parseFloat(row.totalPrice / row.goodsNum).toFixed(2);
                }).catch(() => {
                  row.price = rowData.price
                })
              } else {
                row.price = parseFloat(row.totalPrice / row.goodsNum).toFixed(2);
              }
            }
          } else {
            row.totalPrice = rowData.totalPrice.toString();
          }

        } else {
          if ((row.totalPrice == null || row.totalPrice === '' || row.totalPrice === undefined) &&
            (row.goodsNum === null || row.goodsNum === '' || row.goodsNum === 0)) {
            row.goodsNum = rowData.goodsNum.toString();
            row.price = rowData.price.toString();
            row.totalPrice = rowData.totalPrice.toString();
          } else {
            row.totalPrice = rowData.totalPrice.toString();
            row.price = '0.00';
          }
        }
        this.$refs['listOperation'].setCountData(row, index);
      },
      // 提交数据
      submitAuth(e) {
        if (!this.isCheck) {
          // 将商品list的值重新赋值给后端接收的参数
          let tableList = this.$refs['listOperation'].getTabelData();
          let orderNumber = 1;
          tableList.map(item => {
            item.orderNumber = orderNumber++;
            item.goodsId = item.goodsId || item.id;
            item.type = 20;
          });
          // 将合计的值重新赋值给后端接收的参数
          let totalParam = this.$refs['listOperation'].getSumData();
          totalParam.orderAmt = totalParam.totalPrice;
          // 将表头的值重新赋值给后端接收的参数
          let headParam = this.$refs.listOperationForm.getFormModel();
          headParam.reviewerStatus = 20;
          let searchParam = {
            ...{pcGoodsMapList: tableList},
            ...totalParam,
            ...headParam
          };
          if (!headParam.supplierId) {
            this.$confirm('请选择供应商！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            });
          } else if (headParam.warehouseId === undefined) {
            this.$confirm('请选择仓库！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            });
          } else if (tableList.length === 0) {
            this.$message({message: '商品信息无效！', type: 'warning'});
          } else {
            let testSave = false
            testSave = tableList.every(v => {
              if (v.goodsName && v.barCode) {
                return true
              } else {
                return false
              }
            })
            let length = 0;
            let lengthPrice = 0;
            tableList.map(table => {
              // if (table.goodsNum === 0) {
              if ((table.giveGoodsNum + table.goodsNum) <= 0) {
                length = length + 1;
              }
              if (table.price <= 0) {
                lengthPrice = lengthPrice + 1;
              }
            });
            let priceFlag = false
            let mountFlag = false
            tableList.map(item => {
              for (let key in item) {
                if (this.validePirce(key)) {
                  if (item[key] > 99999.99) {
                    priceFlag = true
                  }
                }
                if (this.valideMount(key)) {
                  if (item[key] > 9999.999) {
                    mountFlag = true
                  }
                }
              }
            })
            if (mountFlag) return this.$message.warning('数量相关不能超过9999.999')
            if (priceFlag) return this.$message.warning('价格不能超过99999.99')
            if (testSave) {
              if (length > 0) {
                this.$message({message: '存在数量为0的商品，不能进行保存/审核！', type: 'warning'});
              } else {
                if (lengthPrice > 0) {
                  this.$confirm('存在进价为0的商品,是否继续保存/审核?', '提示',
                    {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                    }
                  ).then(() => {
                    this.saveData(headParam, e, searchParam);
                  });
                } else {
                  this.saveData(headParam, e, searchParam);
                }
              }
            }
          }
        }
      },
      validePirce(val) {
        const priceArray = ['buyPrice', 'deliveryPrice', 'lowestPrice', 'plusVipPrice', 'retailPrice', 'tradePrice', 'vipPrice'];
        if (priceArray.includes(val)) {
          return true
        } else {
          return false
        }
      },
      valideMount(val) {
        const mountArray = ['giveGoodsNum', 'goodsNum', 'inventoryNum'];
        if (mountArray.includes(val)) {
          return true
        } else {
          return false
        }
      },
      saveData(headParam, e, searchParam) {
        if (headParam.id) {
          if (e === 3) {
            this.$confirm('是否确认审核?', '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }
            ).then(() => {
              this.handleRequest(this.$axios.fetchPost(api.purchase.stock + '/audit', searchParam), e);
            }).catch(() => this.$message({message: '审核取消！', type: 'info'}));
          } else {
            this.$confirm('是否确认保存?', '提示',
              {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }
            ).then(() => {
              this.handleRequest(this.$axios.fetchPut(api.purchase.stock, searchParam), e);
            }).catch(() => this.$message({message: '保存取消！', type: 'info'}));
          }
        } else {
          this.$confirm('是否确认保存?', '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          ).then(() => {
            this.handleRequest(this.$axios.fetchPost(api.purchase.stock, searchParam), e);
          }).catch(() => this.$message({message: '保存取消！', type: 'info'}));
        }
      },

      handleRequest(param, e) {
        const loading = this.$loading({
          lock: true,
          text: '提交中，请稍候...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        param.then((data) => {
          if (data.code === 200) {
            if (e === 3) {
              this.$notify({
                type: "success",
                title: '审核操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '审核成功！', type: 'success'});
              this.$router.push({path: '/purchase/stock'});
            } else {
              this.$notify({
                type: "success",
                title: '保存操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '保存成功！', type: 'success'});
              this.dialogShow = false;
              this.$refs.listOperationForm.formModel = data.data;
              this.formModel.reviewerStatus = data.data.reviewerStatus;
            }
          } else {
            if (e === 3) {
              this.$notify({
                type: "error",
                title: '审核操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({message: '审核失败！' + data.code + ':' + data.errorMsg, type: 'error'})
            } else {
              this.$notify({
                type: "error",
                title: '保存操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({message: '保存失败！' + data.code + ':' + data.errorMsg, type: 'error'})
            }
          }
          loading.close()
        })
          .catch((err) => {
            this.$message({message: '请求失败！', type: 'error'});
            loading.close()
          });
      },
      // 获取采购单
      getPurchaseOrderNo(data) {
        // 在选择供应商之前应该进行数据清零
        this.$refs['listOperation'].clearTableData();
        this.$axios
          .fetchPost(api.purchase.order + '/unfinished/order/list', {
            reviewerStatus: 10,
            supplierId: data.supplierId,
            warehouseId: data.warehouseId
          })
          .then((data) => {
            if (data.code === 200) {
              this.listFormOptions.columns.filter(item => item.prop === 'purchaseOrderNo')[0].data = data.data;
              // this.$refs.listOperationForm.formModel.orderNo = "";
              // this.$refs.listOperationForm.formModel.handler = "";
              // this.$refs.listOperationForm.formModel.purchaseOrderNo = '';
              this.$set(this.$refs.listOperationForm.formModel, 'purchaseOrderNo', '');
              // this.$refs.listOperationForm.formModel.purchaseId = "";
              // this.$refs.listOperationForm.formModel.goodsArriveDttm = "";
              // this.$refs.listOperationForm.formModel.remarks = "";
              // this.$refs.listOperationForm.formModel.warehouseId = "";
            }
          });
      },
      // 选择采购订单
      purchaseOrderNoChange(item) {
        this.$refs['listOperation'].clearTableData();
        let data = this.$refs.listOperationForm.formModel;
        data.purchaseId = item.id;
        data.purchaseOrderNo = item.orderNo;
        this.loading = true;
        // this.$refs.listOperationForm.formModel.warehouseId = item.warehouseId;
        this.isSelectWarehouse = false;
        this.$axios
          .fetchPost(api.purchase.goods + '/goods/list', {
            orderNo: data.purchaseOrderNo, type: 10
          })
          .then((goodsData) => {
            this.loading = false;
            if (goodsData.code === 200) {
              this.goodsCopyList = this.$utils.deepClone(goodsData.data);
              this.goodsCopyList.map((item) => {
                item.name = item.goodsName;
                item.id = item.goodsId;
                // 多行填充的时候给折扣一个初始值
                item.discountRate = 1.0.toFixed(2);// 折扣率
                item.noStorageNum = 0.0.toFixed(2); // 不入库数量
                item.isFinalNum = 1; // 是否是商品最终入库数量
              });
              console.log(this.goodsCopyList)
              this.$refs['listOperation'].addMoreRow(this.goodsCopyList, this.checkIndex);
              this.currentTableList = this.$refs['listOperation'].getTabelData();
            }
          });
      },
      // 选择仓库
      warehouseChange(data) {
        if (this.isClearTableData) {
          this.$refs['listOperation'].clearTableData();
          this.$refs.listOperationForm.formModel.purchaseOrderNo = '';
          this.getPurchaseOrderNo(data);
        } else {
          this.isClearTableData = true;
        }
        this.supplierInfo.warehouseId = data.warehouseId;
        this.isSelectWarehouse = false;
      },
      // 下载模板
      downloadTemplate() {
        if (!this.isCheck) {
          this.$axios.fetchPost(api.purchase.templateDown + '?&downType=20').then(data => {
            if (data.code === 200) {
              const elink = document.createElement('a');
              elink.href = data.data;
              elink.click();
              this.loadingExt = false;
              this.$notify({
                type: "success",
                title: '导出操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '导出成功', type: 'success'});
            } else {
              this.$notify({
                type: "error",
                title: '导出操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({message: '导出异常', type: 'error'});
            }
          })
        }
      },
      // 导入
      importData() {
        if (!this.isCheck) {
          let tableData = this.$refs.listOperationForm.formModel;
          if (tableData.supplierId) {
            if (tableData.warehouseId) {
              this.$utils.uploadFile((file) => {
                this.loading = true;
                let formData = new FormData();
                formData.append('multipartFile', file);
                formData.append('supplierId', tableData.supplierId);
                formData.append('warehouseId', tableData.warehouseId);
                formData.append('businessType', 10);
                this.$refs['listOperation'].clearTableData();
                const loading = this.$loading({
                  lock: true,
                  text: '提交中，请稍候...',
                  background: 'rgba(225, 225, 225, 0.8)'
                });
                this.$axios
                  .fetchPostGoodsExport(api.purchase.purchaseImport, formData)
                  .then(data => {
                    if (data.code === 200) {
                      //关闭导入弹窗
                      this.importShow = false;
                      // 为表格赋值
                      if (data.data.pcGoodsMapMVOList) {
                        data.data.pcGoodsMapMVOList.map((item, index) => {
                          item.id = index + 1;
                          item.salesAmount = (item.retailPrice * item.goodsNum).toFixed(2);
                          item.noStorageNum = '0.00';
                          if (!item.price) {
                            item.price = item.buyPrice;
                          }
                          item.totalPrice = (item.price * item.goodsNum).toFixed(2);
                          if (!item.discountRate) {
                            item.discountRate = '1.00';
                          } else {
                            item.totalPrice = (item.totalPrice * item.discountRate).toFixed(2);
                          }
                        });
                        this.currentTableList = data.data.pcGoodsMapMVOList;
                        this.$refs['listOperation'].addMoreRow(data.data.pcGoodsMapMVOList, 0);
                      }
                      if (data.data.errorBatchId) {
                        this.exportErrorData(data.data.errorBatchId);
                      }
                    } else {
                      if (data.errorMsg) {
                        this.$message({message: data.errorMsg, type: 'error'});
                      } else {
                        this.$notify({
                          type: "error",
                          title: '导入操作',
                          message: '失败',
                          showClose: false,
                        });
                        // this.$message({message: '导入异常', type: 'error'});
                      }
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  }).finally(() => {
                  this.loading = false;
                  loading.close()
                });
              });
            } else {
              this.$message({message: '请选择仓库！', type: 'warning'});
            }
          } else {
            this.$message({message: '请选择供应商！', type: 'warning'});
          }
        }
      },
      // 导入的错误数据
      exportErrorData(id) {
        const loading = this.$loading({
          lock: true,
          text: '正在导出...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        this.$axios.PostBlob(api.system.exportError + '?batchId=' + id, '').then(res => {
          if (res.status === 200) {
            const fileName = '采购收货错误数据' + '_' + this.$utils.getDateTime() + ".xlsx";
            let blob = new Blob([res.data])
            let downloadElement = document.createElement('a');
            let href = window.URL.createObjectURL(blob); //创建下载的链接
            downloadElement.href = href;
            downloadElement.download = fileName; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
            // this.$message.success("导出成功,文件名称:" + fileName);
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功!文件名称:' + fileName,
              showClose: false,
            });
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message.error("导出失败,请稍后再试");
          }
        }).catch(() => {
          this.$message.warning("当前导出数据为空或超出10000条。");
        }).finally(() => {
          loading.close();
        });
      },

      purchaseStoreChange(row) {
        // 通过门店id获取供应商以及仓库
        this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: row.storeId}).then(data => {
          if (data.code === 200) {
            row.supplierId = '';
            this.listFormOptions.columns.filter(item => item.prop === 'supplierId')[0].data = data.data;
          } else {
            this.$message({message: '获取供应商失败!', type: 'error'});
          }
        });
        this.$axios.fetchPost(api.warehouse.warehouse + '/query/warehouse/list', {storeId: row.storeId}).then(data => {
          if (data.code === 200) {
            row.warehouseId = '';
            this.listFormOptions.columns.filter(item => item.prop === 'warehouseId')[0].data = data.data;
            if (data.data) {
              data.data.map(item => {
                if (item.defaultState === true) {
                  row.warehouseId = item.id;
                  this.isSelectWarehouse = false;
                  this.otherParam.warehouseId = item.id;
                }
              })
            }
          } else {
            this.$message({message: '获取仓库失败!', type: 'error'});
          }
        });
        if (!this.$route.query.id) {
          this.$nextTick(() => {
            this.otherParam.storeId = row.storeId;
            this.$nextTick(() => {
              this.$refs['listOperation'].clearTableData();
              this.listFormOptions.columns.filter(item => item.prop === 'purchaseOrderNo')[0].data = [];
              this.$refs.listOperationForm.formModel.purchaseOrderNo = '';
              this.$refs.listOperationForm.formModel.supplierId = '';
              this.supplierInfo.supplierId = ''
              this.isSelectSupplier = true;
            });
          });
        }
      },

      openImport() {
        if (!this.isCheck) {
          let tableData = this.$refs.listOperationForm.formModel;
          if (tableData.supplierId) {
            if (tableData.warehouseId) {
              this.importShow = true;
            } else {
              this.$message.warning("请选择仓库")
            }
          } else {
            this.$message.warning("请选择供应商")
          }
        }
      },
    }
  };
</script>
<style scoped>
  >>> .el-dialog__header {
    margin-bottom: 5px;
  }

  .order-add-page .search-goods-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    margin-bottom: 10px;
  }

  .order-add-page .search-goods-box .select-good {
    margin-left: 16px;
  }

  .search-goods-input {
    width: 300px;
  }

  /deep/ #goodsText {
    height: 32px;
  }

  /deep/ .importDialog {
    width: 640px;
    min-width: 640px;
  }
</style>



// WEBPACK FOOTER //
// src/page/purchase/StockAdd.vue